import { customer } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';
import { handleApiError } from '../api-crud.utils';

export function get({ url: { service: baseUrl }, token }: IAPI) {
  return async function getCustomer(id: string): Promise<customer.Customer> {
    const url = new URL(`/customer/${id}`, baseUrl);
    if (!token) {
      throw new Error('Missing token');
    }
    const response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    if (!response.ok) {
      return handleApiError(response, 'GET', url.toString());
    }
    return await response.json();
  };
}

export function findByEmail({ url: { service: baseUrl }, token }: IAPI) {
  return async function findByEmail(
    email: string
  ): Promise<customer.Customer[]> {
    const url = new URL(
      `/customer?email=${encodeURIComponent(email)}`,
      baseUrl
    );
    if (!token) {
      throw new Error('Missing token');
    }
    const response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    if (!response.ok) {
      return handleApiError(response, 'GET', url.toString());
    }
    return await response.json();
  };
}

export async function postCustomer(
  baseUrl: string,
  customer: customer.CreateCustomer
): Promise<customer.CreateCustomer> {
  const url = new URL(`/customer?accepted_terms`, baseUrl);
  const response = await fetch(url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(customer),
  });
  if (!response.ok) {
    return handleApiError(response, 'POST', url.toString());
  }
  return await response.json();
}

export function patchCustomer({ url: { service: baseUrl }, token }: IAPI) {
  return async function patchCustomer(
    id: string,
    customer: customer.UpdateCustomer,
    options?: { keepalive?: boolean; signal?: AbortSignal }
  ): Promise<customer.Customer> {
    const url = new URL(`/customer/${id}`, baseUrl);
    if (!token) {
      throw new Error('Missing token');
    }
    const response = await fetch(url, {
      method: 'PATCH',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(customer),
      ...(options?.keepalive ? { keepalive: true } : {}),
      ...(options?.signal ? { signal: options.signal } : {}),
    });
    if (!response.ok) {
      return handleApiError(response, 'PATCH', url.toString());
    }
    return await response.json();
  };
}

export function revokeMarketingConsent({
  url: { service: baseUrl },
  token,
}: IAPI) {
  return async function revokeMarketingConsent(
    customerID: string
  ): Promise<customer.Customer> {
    const url = new URL(`/customer/${customerID}/consent`, baseUrl);
    if (!token) {
      throw new Error('Missing token');
    }
    const response = await fetch(url, {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    if (!response.ok) {
      return handleApiError(response, 'DELETE', url.toString());
    }
    return await response.json();
  };
}
